// src/SearchHistory.js
import React, { useState, useEffect } from 'react';

function SearchHistory({ searchHistory = [], getPopularScenarios, onScenarioSelect }) {
  const [popularScenarios, setPopularScenarios] = useState([]);
  const [timeframe, setTimeframe] = useState('day');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadPopularScenarios = async () => {
      setLoading(true);
      try {
        const scenarios = await getPopularScenarios(timeframe);
        setPopularScenarios(scenarios || []);
      } catch (error) {
        console.error('Error loading popular scenarios:', error);
        setPopularScenarios([]);
      } finally {
        setLoading(false);
      }
    };

    loadPopularScenarios();
  }, [timeframe, getPopularScenarios]);

  return (
    <div className="search-history-container">
      <div className="recent-searches">
        <h2>Recent Searches</h2>
        <ul className="search-list">
          {searchHistory.map((search, index) => (
            <li 
              key={index} 
              onClick={() => onScenarioSelect(search.searchTerm || search)}
              className="search-item"
            >
              {search.searchTerm || search}
            </li>
          ))}
        </ul>
      </div>

      <div className="popular-scenarios">
        <div className="popular-header">
          <h2>Popular Scenarios</h2>
          <select 
            value={timeframe} 
            onChange={(e) => setTimeframe(e.target.value)}
            className="timeframe-select"
          >
            <option value="day">Today</option>
            <option value="week">This Week</option>
            <option value="all">All Time</option>
          </select>
        </div>
        
        {loading ? (
          <div className="loading">Loading popular scenarios...</div>
        ) : (
          <ul className="popular-list">
            {popularScenarios.map((scenario, index) => (
              <li 
                key={index}
                onClick={() => onScenarioSelect(scenario.text)}
                className="popular-item"
              >
                <span className="scenario-text">{scenario.text}</span>
                <span className="view-count">{scenario.views} views</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default SearchHistory;